<template>
  <div class="LoginForm d-flex flex-column h-100">
    <h1 class="text-center mb-4 pb-2">Account herstel</h1>
    <div style="min-height: 80px">
      <Feedback :feedback="feedback" />
    </div>
    <Form 
      class="flex-grow-1"
      @submit="handleSubmit">

      <FormField 
        v-model="fields.email.value"
        v-bind="fields.email" />
      
      <button 
        type="submit"
        :disabled='isDisabled'
        class="btn btn-success btn-lg btn-block rounded-pill font-weight-bold border-0 mt-3 p-3">
        Stuur e-mail
      </button>
      <p class="text-muted mt-2 text-center">
        Limiet ivm beveiliging: eens per 30 minuten
      </p>
    </Form>

    <div class="d-flex justify-content-center mt-5">
      <router-link 
        class="text-muted"
        :to="{ name: 'login' }">
        Terug naar login
      </router-link>
    </div>
  </div>
</template>

<script>
import { requestPasswordRecovery } from 'service/auth'

import { required, email } from 'vuelidate/lib/validators';

import Feedback from 'atom/Feedback'
import Form from 'molecule/form/Form'
import FormField from 'molecule/form/FormField'

import fields from 'mixin/fields'

export default {
  name: 'RequestResetForm',
  components: {
    Feedback,
    Form,
    FormField
  },
  mixins: [ fields ],
  data() {
    return {
      feedback: {},
      isDisabled: false,
      fields: {
        email: {
          label: "E-mail",
          autocomplete: "username",
          type: "email",
          placeholder: "naam@bedrijf.nl",
          value: '',
          validationRules: {
            required, email
          },
          disabled: false
        }
      }
    }
  },
  created() {
    this.feedback = {
      variant: 'info', 
      message: 'Het account kan via een e-mail hersteld worden.'
    }
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      
      this.disableAllFields()
      this.isDisabled = true
      this.feedback = {
        variant: 'info', 
        message: 'Bezig met versturen...'
      }
      
      requestPasswordRecovery({
        email:    this.fieldValue('email')
      })
        .then(() => {
          this.enableAllFields()
          this.isDisabled = false
          this.feedback = {
            variant: 'success', 
            message: 'We hebben een e-mail verzonden.'
          }
        })
        .catch((err) => {
          this.enableAllFields()
          this.isDisabled = false
          if (err && err.status === 404) {
            this.feedback = {
              variant: 'danger', 
              message: 'Dit e-mailadres is niet geregisteerd'
            }
          } else {
            this.feedback = {
              variant: 'danger', 
              message: 'Onbekende fout. Probeer het later nog eens.'
            }
          }
        })
    },
  }
}
</script>
